import React from "react";
import styles from './offers.module.css';
import withRouter from "@/components/functional-hook-wrapper";

export class HomeOffers extends React.Component {
    state = {
        title: 'Kwik Fill',
        body: 'Operation Give Thanks Giveaway!',
        button_title: 'Enter Now',
        imageUrl: 'https://operation-give-thanks.s3.us-east-1.amazonaws.com/website/january.png'
    }
    
    router: any;

    constructor(props: any) {
        super(props);
        this.router = props.router;
    }

    componentDidMount() {
        this.fetchImageUrl();
    }

    fetchImageUrl() {
        fetch('https://kwik.burcs.workers.dev/query', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer 1b08552890094f86e6038a16d3b4d51a30aec0468565536e55c28e380f7488b2',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sql: `
                    SELECT r2_key
                    FROM media
                    WHERE id = 1 AND originalname = 'giveaway.png'
                `
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data && data.result && data.result.length > 0 && data.result[0].r2_key) {
                this.setState({ imageUrl: data.result[0].r2_key });
            }
        })
        .catch(error => {
            console.error('Error fetching image URL:', error);
        });
    }

    render() {
        return (
            <div className={styles.container} onClick={() => { this.router.navigate('/win') }}>
                <div className={styles.container_inner} style={{backgroundImage: `url(${this.state.imageUrl})`}}>
                    {/* <div className={styles.button}>{this.state.button_title}</div> */}
                </div>
            </div>
        );
    }
}

export default withRouter(HomeOffers);
